import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "m-3 text-4xl pt-6 font-display" }, "vocabulary", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-sm pb-4"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" type the word or phrase ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("in foreign language ")
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "text-error pt-4",
  "data-aos": "fade-in"
}

import { LanguageInfo } from "@/LanguageInfo";
import { store } from "@/store";
import { computed } from "vue";
import MyInput from "@/components/MyInput.vue";
import LanguageDropdown from "@/components/LanguageDropdown.vue";

interface AddCardFrontProps {
  frontLanguage: LanguageInfo;
  word: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    frontLanguage: null,
    word: null
  },
  emits: ["input", "language-change"],
  setup(__props: any, { emit }) {

const props = __props as {
  frontLanguage: LanguageInfo;
  word: string;
}

function onLanguageChange(language: LanguageInfo) {
  emit("language-change", language);
}

function onInput(text: string) {
  emit("input", text);
}





const cards = computed(() => {
  return store?.state?.user?.cards;
});

const isAlreadyInDeck = computed(() => {
  let word = props.word;
  if (word == null || word == "") return false;
  return cards.value?.some((x: any) => x.front == word) ?? false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!__props.word)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _hoisted_6))
      : _createCommentVNode("", true),
    _createVNode(MyInput, {
      value: __props.word,
      onInputText: onInput,
      maxlength: "30"
    }, null, 8, ["value"]),
    (_unref(isAlreadyInDeck))
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, " you have already added this vocabulary "))
      : _createCommentVNode("", true),
    _createVNode(LanguageDropdown, {
      class: "my-2",
      current: __props.frontLanguage,
      onSelected: onLanguageChange
    }, null, 8, ["current"])
  ], 64))
}
}

})